export const MAP_PROVIDER_OPENSTREETMAP_CODE = 'MSP_001'
export const MAP_PROVIDER_GOOGLE_CODE = 'MSP_002'

export type MapProviderKey = 'openstreetmap' | 'googlemaps'

export type MapProviderOption = {
  code: string
  key: MapProviderKey
  label: string
  helpText: string
}

export const MAP_PROVIDER_OPTIONS: ReadonlyArray<MapProviderOption> = [
  {
    code: MAP_PROVIDER_OPENSTREETMAP_CODE,
    key: 'openstreetmap',
    label: 'OpenStreetMap (Nominatim)',
    helpText: 'No API key required.',
  },
  {
    code: MAP_PROVIDER_GOOGLE_CODE,
    key: 'googlemaps',
    label: 'Google Maps Geocoding',
    helpText: 'Uses configured maps_api_key from Credentials.',
  },
] as const

const MAP_PROVIDER_BY_CODE = new Map(MAP_PROVIDER_OPTIONS.map((option) => [option.code, option]))
const MAP_PROVIDER_BY_KEY = new Map(MAP_PROVIDER_OPTIONS.map((option) => [option.key, option]))

export function getMapProviderByCode(code?: string | null): MapProviderOption | null {
  if (!code) {
    return null
  }
  return MAP_PROVIDER_BY_CODE.get(code.trim()) ?? null
}

export function getMapProviderByKey(key?: string | null): MapProviderOption | null {
  if (!key) {
    return null
  }
  return MAP_PROVIDER_BY_KEY.get(key.trim().toLowerCase() as MapProviderKey) ?? null
}

export function resolveMapProviderCode(value?: string | null): string {
  const byCode = getMapProviderByCode(value)
  if (byCode) {
    return byCode.code
  }

  const normalizedValue = String(value ?? '').trim().toLowerCase()
  if (normalizedValue === 'google' || normalizedValue === 'googlemaps') {
    return MAP_PROVIDER_GOOGLE_CODE
  }

  if (normalizedValue === 'openstreetmap' || normalizedValue === 'osm') {
    return MAP_PROVIDER_OPENSTREETMAP_CODE
  }

  return MAP_PROVIDER_OPENSTREETMAP_CODE
}

export function resolveMapProviderKey(value?: string | null): MapProviderKey {
  const byCode = getMapProviderByCode(value)
  if (byCode) {
    return byCode.key
  }

  const byKey = getMapProviderByKey(value)
  if (byKey) {
    return byKey.key
  }

  if (String(value ?? '').trim().toLowerCase() === 'google') {
    return 'googlemaps'
  }

  return 'openstreetmap'
}
